import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "input", "counter", "submit" ]
  static values = { min: { type: Number, default: 50 } }

  connect() {
    this.boundUpdate = this.update.bind(this)
    const inputEl = this.getInputElement()
    if (inputEl) {
      inputEl.addEventListener("input", this.boundUpdate)
      inputEl.addEventListener("keyup", this.boundUpdate)
      inputEl.addEventListener("change", this.boundUpdate)
    }
    this.update()
  }

  disconnect() {
    const inputEl = this.getInputElement()
    if (inputEl && this.boundUpdate) {
      inputEl.removeEventListener("input", this.boundUpdate)
      inputEl.removeEventListener("keyup", this.boundUpdate)
      inputEl.removeEventListener("change", this.boundUpdate)
    }
  }

  getInputElement() {
    return this.hasInputTarget ? this.inputTarget : this.element.querySelector("textarea, input[type=text]")
  }

  update(event) {
    const inputEl = (event && event.target && event.target.value !== undefined) ? event.target : this.getInputElement()
    if (!inputEl) return

    const length = inputEl.value.length
    const min = this.hasMinValue ? this.minValue : (parseInt(inputEl.getAttribute("minlength"), 10) || 50)

    const counterEl = this.hasCounterTarget ? this.counterTarget : this.element.querySelector(".char-counter")
    if (counterEl) {
      counterEl.textContent = `${length}/${min}`
      if (length >= min) {
        counterEl.className = "char-counter text-green-600 font-semibold"
      } else {
        counterEl.className = "char-counter text-gray-400"
      }
    }

    const submitEl = this.hasSubmitTarget ? this.submitTarget : this.element.querySelector("input[type=submit], button[type=submit]")
    if (submitEl) {
      if (length >= min) {
        submitEl.disabled = false
        submitEl.classList.remove("opacity-50", "cursor-not-allowed")
        submitEl.classList.add("cursor-pointer")
      } else {
        submitEl.disabled = true
        submitEl.classList.add("opacity-50", "cursor-not-allowed")
        submitEl.classList.remove("cursor-pointer")
      }
    }
  }
}
